<template>
  <div class="dashboard">
    <dashboard-stats-adherents syndicat="unpf" />
    <dashboard-table-Adherents syndicat="unpf" />
  </div>
</template>

<script>
import DashboardStatsAdherents from "./DashboardStatsAdherents";
import DashboardTableAdherents from "./DashboardTableAdherents";

export default {
  name: "dashboard",
  components: {
    DashboardStatsAdherents,
    DashboardTableAdherents
  },

  methods: {},
  mounted() {}
};
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0;
  }
}
</style>
